<template>
  <div>
    <!-- Approve or Reject Confirmation form -->
    <template v-if="this.showConfirmForm">
      <div class="card my-2 mx-md-5">
        <b-card-header class="esep-blue-bg text-light">
          <h6 class="float-left font-weight-bold">{{ $t(`jamboree.${formType === 'APPROVE' ? 'approve' : 'reject'}`) }} {{
            selectedJamboreePayment.id }}
          </h6>
        </b-card-header>
        <b-card-body>
          <div class="d-flex">
            <label>
              {{ $t('jamboree.areYouSure', { type: $t(`jamboree.${formType === 'APPROVE' ? 'approve' : 'reject'}`) }) }}
            </label>
          </div>
          <b-form-group id="input-group-comment" :label="$t('jamboree.comments')" label-for="input-comment"
            label-align="left" class="col-md-12">
            <b-form-input id="input-comment" v-model="comments" type="text"></b-form-input>
          </b-form-group>
          <div class="float-left mt-2">
            <b-button @click="submitApproveRejectJamboreePayment(formType)" variant="success" class="mr-1">{{
              $t("common.submit")
            }}</b-button>
            <b-button @click="hideForm" variant="danger">{{
              $t("common.cancel")
            }}</b-button>
          </div>
        </b-card-body>
      </div>
    </template>
    <b-modal :title="$t('licenses.proposalComments')" id="comments-modal" size="xl" hide-footer responsive>
      <template v-if="this.selectedJamboreePayment != null">
        <b-table :items="this.selectedJamboreePayment.wfSteps" :fields="wfStepFields" responsive show-empty
          thead-class="esep-blue-bg text-light" sort-by="id" :sort-desc="true">
          <template v-slot:cell(approved)="data">
            <b-icon icon="check-circle" variant="success" v-if="data.item.approved"></b-icon>
            <b-icon icon="x-circle" variant="danger" v-else-if="data.item.approved === false"></b-icon>
          </template>

        </b-table>
      </template>
    </b-modal>

    <JamboreeToolbar />
    <div class="card  mx-md-5 mt-3 mb-3 bg-form">
      <card-header :title="$t('jamboree.managementTitle')" :iconName="'person-fill'" />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert" variant="danger" dismissible>
          {{ error.message }}
        </b-alert>

        <b-row>
          <v-select
            :options="this.jamboreeList"
            v-model="selectedJamboree"
            :placeholder="$t('jamboree.selectJamboree')"
            label="title"
            class="bg-white rounded col"
          />
          
          <v-select 
            :options="this.usersAccessibleUnits" 
            v-model="selectedUnit" 
            :placeholder="$t('jamboree.selectUnit')"
            label="name" 
            class="bg-white rounded col" />
          
          <b-button class="ml-auto my-auto mr-3 esep-blue-bg" variant="primary" @click="getJamboreePayments">
            {{ $t('common.search') }}
          </b-button>
        </b-row>

        <b-table :items="jamboreePayments" :fields="jamboreePaymentFields" show-empty
          thead-class="esep-blue-bg text-light" class="mt-3">

          <template v-slot:cell(action)="row">
            <router-link :to="{ path: `/jamboree/payment/${row.item.id}` }" target="_blank">
              <b-button size="sm" variant="transparent">
                <b-icon icon="eye"></b-icon>
              </b-button>
            </router-link>
            <b-button size="sm" @click="submitJamboreePayment(row.item)" variant="transparent"
              v-if="row.item.status === 'DRAFT'">
              <b-icon icon="cart-check"></b-icon>
            </b-button>
            <b-button size="sm" @click="deleteJamboreePayment(row.item)" variant="transparent"
              v-if="row.item.status !== 'PROCESSED'">
              <b-icon icon="trash"></b-icon>
            </b-button>
          </template>

        </b-table>

        <hr />


      </b-card-body>

    </div>
  </div>
</template>


<script>
import JamboreeToolbar from "@/views/jamboree/JamboreeToolbar";
import { roles, routes } from "esep/src/services/routing.service";
import { hasRole } from "esep/src/services/utils";
import cardHeader from '../../components/common/cardHeader.vue';
import { handleApiError } from '../../services/error.service';
import memberService from '../../services/member.service';
import { prettifyDate } from "@/services/utils";

export default {
  components: { JamboreeToolbar, cardHeader },
  data() {
    return {
      popAlert: false,
      errors: [],
      popSuccessAlert: false,
      successMessage: null,
      selectedUnit: null,
      jamboreeList: [],
      selectedJamboree: null,
      jamboreePayments: [],
      usersAccessibleUnits: [],
      formType: null,
      selectedJamboreePayment: null,
      showConfirmForm: false,
      comments: '',
      jamboreePaymentFields: [
        { key: "jamboree.title", label: "Δράση", sortable: false, thClass: 'text-left', tdClass: 'text-left' },
        { key: "status", label: "Κατάσταση", formatter: "translateStatus" },
        { key: "unit.name", label: "Κλιμάκιο", },
        { key: "totalAmount", label: "Κόστος", formatter: "translateAmount" },
        { key: "rfCode", label: "Κωδικός Πληρωμής" },
        { key: "action", label: "Ενέργεια", sortable: false, thStyle: 'min-width: 168px' }
      ],
      wfStepFields: [
        { key: "approved", label: "" },
        { key: "approver.surName", label: "Επώνυμο" },
        { key: "approver.firstName", label: "Όνομα" },
        { key: "title", label: "Καθήκοντα", formatter: this.translateTitle },
        { key: "approvedDate", label: "Ημ. Ενέργειας", formatter: this.prettifyDate },
        { key: "comments", label: "Σχόλια" },
      ],
    }
  },
  mounted() {
    memberService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        if (!hasRole(this.userInfo, roles.members.jamboree.list)) {
          location.replace(routes.nothing);
        }
        this.$store.state.userInfo = this.userInfo;
        this.fetchAccessibleUnits();
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
    this.getJamborees();
  },
  watch: {
  },
  methods: {
    fetchAccessibleUnits() {
      memberService.getAccessibleUnits(this.username).then(
        (response) => {
          this.usersAdminableUnits = response.data.ADMIN_UNIT;
          this.$store.state.usersAdminableUnits = this.usersAdminableUnits;
          this.usersModableUnits = response.data.MOD_UNIT;
          this.$store.state.usersModableUnits = this.usersModableUnits;
          this.usersAccessibleUnits = response.data.VIEW_UNIT;
          this.$store.state.usersAccessibleUnits = this.usersAccessibleUnits;
          let orgUnit;
          if (this.usersAccessibleUnits.length == 1) {
            orgUnit = this.$store.state.userInfo.orgMember.orgUnit;
          } else {
            orgUnit = this.usersAccessibleUnits.find((unit) => unit.id == parseInt(this.$store.state.globalUnitId));
          }
          this.$store.state.selectedUnit = orgUnit;
          this.selectedUnit = orgUnit;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      );
    },
    handleError(errors) {
      errors.forEach(error => {
        console.error(error);
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length > 0;
    },
    showSuccess(successMessage) {
      this.successMessage = successMessage;
      this.popSuccessAlert = true;
      window.scrollTo(0, 0);
    },
    showForm(jamboreePayment, formType) {
      this.formType = formType;
      this.selectedJamboreePayment = jamboreePayment;
      this.showConfirmForm = true;
      window.scrollTo(0, 0);
    },
    hideForm() {
      this.formType = null;
      this.selectedJamboreePayment = null;
      this.comments = "";
      this.showConfirmForm = false;
    },
    getJamboreePayments() {
      if (this.selectedUnit.id) {
        this.$store.state.globalUnitId = String(this.selectedUnit.id);
        localStorage.setItem('global-selected-unit-id', String(this.selectedUnit.id));
      } else {
        this.$store.state.globalUnitId = null;
        localStorage.clear('global-selected-unit-id');
      }
      console.log(this.selectedJamboree)
      console.log(this.selectedUnit)
      memberService.getJamboreePayments(this.selectedJamboree,this.selectedUnit).then(
        (response) => {
          this.jamboreePayments = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    },
    async canApproveOrReject(payment) {
      let canApprove;
      canApprove = await memberService.canApproveJamboreePayment(payment.id).then(
        () => {
          return true;
        },
        () => {
          return false;
        }
      );
      return canApprove;
    },
    submitApproveRejectJamboreePayment(formTypeToSubmit) {
      memberService.approveRejectJamboreePayment(this.selectedJamboreePayment, {
        approved: formTypeToSubmit === 'APPROVE' ? true : false,
        comments: this.comments
      }).then(
        () => {
          this.getJamboreePayments();
          this.showSuccess(this.$t(`jamboree.${formTypeToSubmit === 'APPROVE' ? 'approve' : 'reject'}Successful`));
          this.hideForm();
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
          this.hideForm();
        }
      )
    },
    submitJamboreePayment(jamboreePayment) {
      memberService.submitJamboreePayment(jamboreePayment, true).then(
        () => {
          this.getJamboreePayments();
          this.showSuccess(this.$t(`jamboree.submitSuccessful`));
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      );
    },
    deleteJamboreePayment(jamboreePayment) {
      memberService.deleteJamboreePayment(jamboreePayment).then(
        () => {
          this.showSuccess(this.$t(`jamboree.deleteSuccessful`));

          for (let j = 0; j < this.jamboreePayments.length; j++) {
            if (this.jamboreePayments[j].id === jamboreePayment.id) {
              this.jamboreePayments.splice(j, 1);
              j = this.jamboreePayments.length;
            }
          }
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      );
    },
    translateStatus(status) {
      return this.$t('jamboreePaymentStatusEnums.' + status);
    },
    translateTitle(status) {
      return this.$t('jamboreePaymentTitleEnums.' + status);
    },
    translateAmount(status) {
      return `${status / 100} €`
    },
    translateRF(rf, _label, item) {
      return item.status === 'APPROVED' || item.status === 'PROCESSED' ? rf : '-';
    },
    showComments(data) {
      this.selectedJamboreePayment = data;
      this.$bvModal.show('comments-modal');
    },
    prettifyDate(stringDate) {
      return prettifyDate(stringDate);
    },
    isApproved(jamboreePayment) {
      return jamboreePayment.wfSteps.some(a => (a.approved));
    },
    getJamborees() {
      memberService.getJamborees().then(
        (response) => {
            this.jamboreeList = response.data
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    }
  }
}
</script>